export default __webpack_public_path__ + "static/media/back-to-top-icon.13cfd09a.svg";